export const UPDATE_CEM_TABLE_LIST = 'UPDATE_CEM_TABLE_LIST'
export const UPDATE_CEM_SHIFT_LIST = 'UPDATE_CEM_SHIFT_LIST'
export const UPDATE_CEM_TEMPLATE_LIST = 'UPDATE_CEM_TEMPLATE_LIST'
export const UPDATE_CEM_CHARGE_LIST = 'UPDATE_CEM_CHARGE_LIST'
export const UPDATE_CEM_SALARY_LIST = 'UPDATE_CEM_SALARY_LIST'



// WEBPACK FOOTER //
// ./src/containers/ClubEmployeeManager/constants.js